module.exports = __webpack_public_path__ + "static/media/banner-limelocker-mobile.c6c3cab6.webp";